import { Store } from 'src/store/index';
import getAbstractProduct from './getAbstractProduct';
import getInternalUid from './getInternalUid';

const getCurrentProduct = (store: Store) => getAbstractProduct(store)?.products.find((product) => product.internalUid === getInternalUid(store));

export default getCurrentProduct;
